import { render, staticRenderFns } from "./uploadGivelessonBook.vue?vue&type=template&id=8079c842"
import script from "./uploadGivelessonBook.vue?vue&type=script&lang=js"
export * from "./uploadGivelessonBook.vue?vue&type=script&lang=js"
import style0 from "./uploadGivelessonBook.vue?vue&type=style&index=0&id=8079c842&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8079c842')) {
      api.createRecord('8079c842', component.options)
    } else {
      api.reload('8079c842', component.options)
    }
    module.hot.accept("./uploadGivelessonBook.vue?vue&type=template&id=8079c842", function () {
      api.rerender('8079c842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/uploadGivelessonBook.vue"
export default component.exports